import React, { useEffect, useState } from "react";
import Axios from "axios";
import "./styles.scss";
import { useHistory } from "react-router-dom";

const Licences = () => {
  const [setLoading] = useState(false);
  const [setResponse] = useState([]);
  const history = useHistory();
  const [licenseType, setLicenseType] = useState();

  useEffect(() => {
    history.location.pathname.indexOf("android")
      ? setLicenseType("android")
      : setLicenseType("ios");
  }, [history.location.pathname]);

  const getLicenseInfo = async () => {
    try {
      setLoading(true);
      const res = await Axios.get(
        "https://tesseractblobstorage.blob.core.windows.net/demo6thfeb/licenses.json"
      );

      setResponse(res?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    // getLicenseInfo();
  }, []);

  return (
    <div className="licenses-wrapper">
      {licenseType === "android" ? (
        <div
          className="license-jioimmerse"
          spellCheck="false"
          tabIndex={0}
          contentEditable="false"
        >
          <div className="info">
            <h2 id="widget">Copyright Notice and License Texts</h2>
            <p id="widget">
              FSensor, Reactive Extensions, Lottie, RxBinding, RxAndroid{" "}
            </p>
            <p id="ap-license">Apache License&nbsp;</p>
            {/* <ul>
              <li className="info-li">Version 2.0, January 2004</li>
              <li className="info-li">http://www.apache.org/licenses/</li>
            </ul> */}

            <p className="info-tnc">
              TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION&nbsp;
            </p>
          </div>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>1. Definitions&nbsp;</h3>
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "License" shall mean the terms and conditions for use,
              reproduction,&nbsp;and distribution as defined by Sections 1
              through 9 of this&nbsp;document.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Licensor" shall mean the copyright owner or entity authorized
              by&nbsp;the copyright owner that is granting the License.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Legal Entity" shall mean the union of the acting entity and
              all&nbsp;other entities that control, are controlled by, or are
              under common&nbsp;control with that entity. For the purposes of
              this definition,&nbsp;"control" means (i) the power, direct or
              indirect, to cause the&nbsp;direction or management of such
              entity, whether by contract or&nbsp;otherwise, or (ii) ownership
              of fifty percent (50%) or more of the&nbsp;outstanding shares, or
              (iii) beneficial ownership of such entity.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "You" (or "Your") shall mean an individual or Legal
              Entity&nbsp;exercising permissions granted by this License.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Source" form shall mean the preferred form for making
              modifications,&nbsp;including but not limited to software source
              code, documentation&nbsp;source, and configuration files.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Object" form shall mean any form resulting from
              mechanical&nbsp;transformation or translation of a Source form,
              including but&nbsp;not limited to compiled object code, generated
              documentation,&nbsp;and conversions to other media types.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Work" shall mean the work of authorship, whether in Source
              or&nbsp;Object form, made available under the License,
              as&nbsp;indicated&nbsp;by a&nbsp;copyright notice that is included
              in or attached to the work&nbsp;(an example is provided in the
              Appendix below).&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Derivative Works" shall mean any work, whether in Source or
              Object&nbsp;form, that is based on (or derived from) the Work and
              for which the&nbsp;editorial revisions, annotations, elaborations,
              or other modifications&nbsp;represent, as a whole,
              an&nbsp;original work of authorship. For the purposes&nbsp;of this
              License, Derivative Works shall not include works
              that&nbsp;remain&nbsp;separable from, or merely link (or bind by
              name) to the interfaces of,&nbsp;the Work and Derivative Works
              thereof.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Contribution" shall mean any work of authorship,
              including&nbsp;the original version of the Work and any
              modifications or additions&nbsp;to that Work or Derivative Works
              thereof, that is intentionally&nbsp;submitted&nbsp;to Licensor for
              inclusion in the Work by the copyright owner&nbsp;or by an
              individual or Legal Entity authorized&nbsp;to&nbsp;submit&nbsp;on
              behalf of&nbsp;the copyright owner. For the purposes of this
              definition, "submitted"&nbsp;means any form of electronic, verbal,
              or written communication sent&nbsp;to the Licensor or its
              representatives, including but not limited to&nbsp;communication
              on electronic mailing lists, source code control systems,&nbsp;and
              issue tracking systems that are managed by, or on behalf of,
              the&nbsp;Licensor for the purpose of discussing and improving the
              Work, but&nbsp;excluding communication that is conspicuously
              marked or otherwise&nbsp;designated in writing by the copyright
              owner as "Not a Contribution."&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Contributor" shall mean Licensor and any individual or Legal
              Entity&nbsp;on behalf of whom a Contribution&nbsp;has been
              received by Licensor and&nbsp;subsequently&nbsp;incorporated
              within the Work.&nbsp;
            </li>
          </ul>

          {/* done till above */}
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>2. Grant of Copyright License</h3>
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Subject to the terms and conditions of&nbsp;this License, each
              Contributor hereby grants to You a perpetual,&nbsp;worldwide,
              non-exclusive, no-charge, royalty-free, irrevocable&nbsp;copyright
              license to reproduce, prepare Derivative Works of,&nbsp;publicly
              display, publicly perform, sublicense, and distribute
              the&nbsp;Work and such Derivative Works in Source or Object
              form.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>3. Grant of Patent License</h3>
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Subject to the terms and conditions of&nbsp;this License, each
              Contributor hereby grants to You a perpetual,&nbsp;worldwide,
              non-exclusive, no-charge, royalty-free, irrevocable&nbsp;(except
              as stated in this section) patent license to make, have
              made,&nbsp;use, offer to sell, sell, import, and otherwise
              transfer the Work,&nbsp;where such license applies only to those
              patent claims licensable&nbsp;by such Contributor that are
              necessarily infringed by their&nbsp;Contribution(s) alone or by
              combination of their Contribution(s)&nbsp;with the Work to which
              such Contribution(s) was submitted. If You&nbsp;institute patent
              litigation against any entity (including
              a&nbsp;cross-claim&nbsp;or counterclaim in a lawsuit) alleging
              that the Work&nbsp;or a Contribution incorporated within the Work
              constitutes direct&nbsp;or contributory patent infringement, then
              any patent licenses&nbsp;granted to You under this License for
              that Work shall&nbsp;terminate&nbsp;as of the date such litigation
              is filed.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>4. Redistribution</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              You may reproduce and distribute copies of the&nbsp;Work or
              Derivative Works thereof in any medium, with or
              without&nbsp;modifications, and in Source or Object
              form,&nbsp;provided that&nbsp;You&nbsp;meet the following
              conditions:&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">(a)&nbsp;</li>
            <li>
              You must give any other recipients of the Work or&nbsp;Derivative
              Works a copy of this License; and&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">(b)&nbsp;</li>
            <li>
              You must cause any modified files to carry prominent
              notices&nbsp;stating that You changed the files; and&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">(c)&nbsp;</li>
            <li>
              You must retain, in the Source form of any Derivative
              Works&nbsp;that You distribute, all copyright, patent, trademark,
              and&nbsp;attribution notices from the Source form of the
              Work,&nbsp;excluding those notices that do&nbsp;not pertain to any
              part of&nbsp;the Derivative Works; and&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">(d)&nbsp;</li>
            <li>
              If the Work includes a "NOTICE" text file as part of
              its&nbsp;distribution, then any Derivative Works that You
              distribute must&nbsp;include a readable copy of the attribution
              notices contained&nbsp;within such NOTICE file, excluding those
              notices that do not&nbsp;pertain to any part of the Derivative
              Works, in at least one&nbsp;of the following places: within a
              NOTICE text file distributed&nbsp;as part of the Derivative Works;
              within the Source form or&nbsp;documentation, if provided along
              with the Derivative Works; or,&nbsp;within a display generated by
              the Derivative Works, if and&nbsp;wherever such third-party
              notices normally appear. The contents&nbsp;of the NOTICE file are
              for informational purposes only and&nbsp;do not modify the
              License. You may add Your own attribution&nbsp;notices within
              Derivative Works that You distribute, alongside&nbsp;or as an
              addendum to the NOTICE text from the Work, provided&nbsp;that such
              additional attribution notices cannot be construed&nbsp;as
              modifying the License.&nbsp;You may add Your own copyright
              statement to Your modifications and&nbsp;may provide additional or
              different license terms and conditions&nbsp;for use, reproduction,
              or distribution of Your modifications, or&nbsp;for any such
              Derivative Works as a whole, provided Your use,&nbsp;reproduction,
              and distribution of the Work otherwise complies with&nbsp;the
              conditions stated in this License.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>5. Submission of Contributions</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Unless You explicitly state otherwise,&nbsp;any Contribution
              intentionally submitted for inclusion in the Work&nbsp;by You to
              the Licensor shall be under the terms and conditions of&nbsp;this
              License, without any additional terms or
              conditions.&nbsp;Notwithstanding the above, nothing herein shall
              supersede or modify&nbsp;the terms of any separate license
              agreement you may have executed&nbsp;with Licensor regarding such
              Contributions.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>6. Trademarks</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              This License does not grant permission to use the
              trade&nbsp;names, trademarks, service marks, or product names of
              the Licensor,&nbsp;except as required for reasonable and customary
              use in describing the&nbsp;origin of the Work and reproducing the
              content of the NOTICE file.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>7. Disclaimer of Warranty</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Unless required by applicable law or&nbsp;agreed to in writing,
              Licensor provides the Work (and each Contributor provides its
              Contributions) on an "AS IS" BASIS,&nbsp;WITHOUT WARRANTIES OR
              CONDITIONS OF ANY KIND, either express or&nbsp;implied, including,
              without limitation, any warranties or conditions&nbsp;of TITLE,
              NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR
              A&nbsp;PARTICULAR PURPOSE. You are solely responsible for
              determining the&nbsp;appropriateness of using or redistributing
              the Work and assume any&nbsp;risks associated with Your exercise
              of permissions under this License.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>8. Limitation of Liability</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              In no event and under no legal theory,&nbsp;whether in tort
              (including negligence), contract, or otherwise,&nbsp;unless
              required by applicable law (such as deliberate and
              grossly&nbsp;negligent acts) or agreed to in writing, shall any
              Contributor be&nbsp;liable to You for damages, including any
              direct, indirect, special,&nbsp;incidental, or consequential
              damages of any character arising as a&nbsp;result of this License
              or out of the use or inability to use the&nbsp;Work (including but
              not limited to damages for loss of goodwill,&nbsp;work stoppage,
              computer failure or malfunction, or any and all&nbsp;other
              commercial damages or losses), even if such Contributor&nbsp;has
              been advised of the possibility of such damages.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>9. Accepting Warranty or Additional Liability</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              While redistributing&nbsp;the Work or Derivative Works
              thereof,&nbsp;You&nbsp;may choose to offer,&nbsp;and charge a fee
              for, acceptance of support, warranty, indemnity,&nbsp;or other
              liability obligations and/or rights consistent with this License.
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              However, in accepting such obligations,&nbsp;You&nbsp;may act
              only&nbsp;on Your own behalf and on Your sole responsibility, not
              on behalf&nbsp;of any other Contributor, and only if You agree to
              indemnify,&nbsp;defend, and hold each Contributor harmless for any
              liability&nbsp;incurred by, or claims asserted against, such
              Contributor by reason&nbsp;of your accepting any such warranty or
              additional liability.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">END OF TERMS AND CONDITIONS&nbsp;</li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>Bubble View&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>MIT License&nbsp;</h3>
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">Copyright 2016&nbsp;MasayukiSuda&nbsp;</li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Permission is hereby granted, free of charge, to any person
              obtaining a copy of this software and associated documentation
              files (the "Software"), to deal in the Software without
              restriction, including without limitation the rights to use, copy,
              modify, merge, publish, distribute, sublicense, and/or sell copies
              of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The above copyright notice and this permission notice shall be
              included in all copies or substantial portions of the
              Software.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
              EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
              NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
              HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
              WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>Microsoft Azure IoT SDK for Java&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>MIT License&nbsp;</h3>
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Copyright (c) Microsoft Corporation&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">All rights reserved.&nbsp;</li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Permission is hereby granted, free of charge, to any person
              obtaining a copy of this software and associated documentation
              files (the ""Software""), to deal in the Software without
              restriction, including without limitation the rights to use, copy,
              modify, merge, publish, distribute, sublicense, and/or sell copies
              of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The above copyright notice and this permission notice shall be
              included in all copies or substantial portions of the
              Software.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The software is provided *as is*, without warranty of any kind,
              express or Implied, including but not limited to the warranties of
              merchantability, Fitness for a particular purpose and
              noninfringement. In no event shall the Authors or copyright
              holders be liable for any claim,&nbsp;damages&nbsp;or other
              Liability, whether in an action of contract, tort or otherwise,
              arising from,&nbsp;Out&nbsp;of or in connection with the software
              or the use or other dealings in&nbsp;The&nbsp;software.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>Firebase Cloud&nbsp;&nbsp;&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>Apache License&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <br />
              Copyright 2017 The Chromium Authors. All rights
              reserved.&nbsp;Redistribution and use in source and binary forms,
              with or without&nbsp;modification, are permitted provided that the
              following conditions&nbsp;are met: &nbsp;&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              &nbsp;* Redistributions of source code must retain the above
              copyright notice, this list of conditions and the following
              disclaimer. &nbsp; &nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              * Redistributions in binary form must reproduce the above
              copyright notice, this list of conditions and the&nbsp;following
              &nbsp;disclaimer&nbsp;in the documentation and/or other materials
              provided with the distribution. &nbsp;&nbsp; * Neither the name of
              Google Inc. nor the names of its &nbsp; &nbsp; &nbsp;contributors
              may be used to endorse or promote products derived &nbsp; &nbsp;
              &nbsp;from this software without specific prior written
              permission.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND
              CONTRIBUTORS"AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
              INCLUDING, BUT NOTLIMITED TO, THE IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS FORA PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHTOWNER OR CONTRIBUTORS
              BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,SPECIAL, EXEMPLARY,
              OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOTLIMITED TO,
              PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,DATA, OR
              PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANYTHEORY
              OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR
              TORT(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF
              THE USEOF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
              SUCH DAMAGE.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>SDP&nbsp;&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>MIT License&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Copyright (c) 2013 - 2022 Intuit Inc.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Permission is hereby granted, free of charge, to any person
              obtaining a copy&nbsp;of this software and associated
              documentation files (the "Software"), to deal&nbsp;in the Software
              without restriction, including without limitation the
              rights&nbsp;to use, copy, modify, merge, publish, distribute,
              sublicense, and/or sell&nbsp;copies of the Software, and to permit
              persons to whom the Software is&nbsp;furnished to do so, subject
              to the following conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The above copyright notice and this permission notice shall be
              included in all&nbsp;copies or substantial portions of the
              Software.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
              EXPRESS OR&nbsp;IMPLIED, INCLUDING BUT NOT LIMITED TO THE
              WARRANTIES OF MERCHANTABILITY,&nbsp;FITNESS FOR A PARTICULAR
              PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE&nbsp;AUTHORS OR
              COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
              OTHER&nbsp;LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
              OTHERWISE, ARISING FROM,&nbsp;OUT OF OR IN CONNECTION WITH THE
              SOFTWARE OR THE USE OR OTHER DEALINGS IN THE&nbsp;SOFTWARE.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>Binary update&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>BSD 2-Clause "Simplified" License&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">Copyright (c) 2015, Scott Motte&nbsp;</li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">All rights reserved.&nbsp;</li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions
              are met:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              * Redistributions of source code must retain the above copyright
              notice, this list of conditions and the following
              disclaimer.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              * Redistributions in binary form must reproduce the above
              copyright&nbsp;notice, &nbsp;this&nbsp;list of conditions and the
              following disclaimer in the documentation &nbsp;and/or other
              materials provided with the distribution.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">&nbsp;</li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND
              CONTRIBUTORS "AS IS"&nbsp;AND ANY EXPRESS OR IMPLIED WARRANTIES,
              INCLUDING, BUT NOT LIMITED TO, THE&nbsp;IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE&nbsp;DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR
              CONTRIBUTORS BE LIABLE&nbsp;FOR ANY DIRECT, INDIRECT, INCIDENTAL,
              SPECIAL, EXEMPLARY, OR CONSEQUENTIAL&nbsp;DAMAGES (INCLUDING, BUT
              NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR&nbsp;SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
              HOWEVER&nbsp;CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
              CONTRACT, STRICT LIABILITY,&nbsp;OR TORT (INCLUDING NEGLIGENCE OR
              OTHERWISE) ARISING IN ANY WAY OUT OF THE USE&nbsp;OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>Checksum for Updates&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>BSD 3-Clause "New" or "Revised" License&nbsp;</h3>
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">Copyright © 2009, Jeff Mott.&nbsp;</li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">All rights reserved.&nbsp;</li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Redistribution and use in source and binary forms, with or without
              modification,&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              are permitted provided that the following conditions are
              met:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">&nbsp;</li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              * Redistributions of source code must retain the above copyright
              notice, this list of conditions and the following
              disclaimer.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              * Redistributions in binary form must reproduce the above
              copyright notice, this &nbsp; list of conditions and the following
              disclaimer in the documentation and/or &nbsp; other materials
              provided with the distribution.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              * Neither the name Crypto-JS nor the names of its contributors may
              be used to endorse or promote products derived from this software
              without specific&nbsp;prior &nbsp;written&nbsp;permission.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">&nbsp;</li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND
              CONTRIBUTORS "AS IS" AND&nbsp;ANY EXPRESS OR IMPLIED WARRANTIES,
              INCLUDING, BUT NOT LIMITED TO, THE IMPLIED&nbsp;WARRANTIES OF
              MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE&nbsp;DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR
              CONTRIBUTORS BE LIABLE FOR&nbsp;ANY DIRECT, INDIRECT, INCIDENTAL,
              SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES&nbsp;(INCLUDING, BUT
              NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES;&nbsp;LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
              INTERRUPTION) HOWEVER CAUSED AND ON&nbsp;ANY THEORY OF LIABILITY,
              WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT&nbsp;(INCLUDING
              NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
              THIS&nbsp;SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGE.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>Tokenization&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>The MIT License&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Copyright (c) 2009-2014 TJ&nbsp;Holowaychuk&nbsp;
              <u>tj@vision-media.ca</u>&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Copyright (c) 2013-2014 Roman&nbsp;Shtylman&nbsp;
              <u>shtylman+expressjs@gmail.com</u>&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Copyright (c) 2014-2015 Douglas Christopher Wilson&nbsp;
              <u>doug@somethingdoug.com</u>&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">&nbsp;</li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Permission is hereby granted, free of charge, to any person
              obtaining a copy of this software and associated documentation
              files (the 'Software'), to deal in the Software without
              restriction, including without limitation the rights to use, copy,
              modify, merge, publish, distribute, sublicense, and/or sell copies
              of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">&nbsp;</li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The above copyright notice and this permission notice shall be
              included in all copies or substantial portions of the
              Software.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
              EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND&nbsp;NON
              INFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
              BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
              ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
              CONNECTION WITH THE&nbsp;SOFTWARE OR THE USE OR OTHER DEALINGS IN
              THE SOFTWARE.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>Custom N unit&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>Charlie Poole, Rob Prouse&nbsp;</h3>
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Copyright (c) 2018 Charlie Poole, Rob Prouse&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Permission is hereby granted, free of charge, to any person
              obtaining a copy of this software and associated documentation
              files (the "Software"), to deal in the Software without
              restriction, including without limitation the rights to use, copy,
              modify, merge, publish, distribute, sublicense, and/or sell copies
              of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The above copyright notice and this permission notice shall be
              included in all copies or substantial portions of the
              Software.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
              EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
              NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
              HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
              WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.&nbsp;
            </li>
          </ul>
        </div>
      ) : (
        <div
          className="license-jioimmerse"
          spellCheck="false"
          tabIndex={0}
          contentEditable="false"
        >
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>Copyright Notice and License Texts</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>Lottie, Realm, Firebase Cloud, DPOTPView </h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>Apache License&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>
                TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND
                DISTRIBUTION&nbsp;
              </h3>
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>1. Definitions&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "License" shall mean the terms and conditions for use,
              reproduction, and distribution as defined by Sections 1 through 9
              of this&nbsp;document.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Licensor" shall mean the copyright owner or entity authorized by
              the copyright owner that is granting the License.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Legal Entity" shall mean the union of the acting entity and all
              other entities that control, are controlled by, or are under
              common control with that entity. For the purposes of this
              definition, "control" means (i) the power, direct or indirect, to
              cause the direction or management of such entity, whether by
              contract or otherwise, or (ii) ownership of fifty percent (50%) or
              more of the outstanding shares, or (iii) beneficial ownership of
              such entity.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "You" (or "Your") shall mean an individual or Legal Entity
              exercising permissions granted by this License.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Source" form shall mean the preferred form for making
              modifications, including but not limited to software source code,
              documentation source, and configuration files.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Object" form shall mean any form resulting from mechanical
              transformation or translation of a Source form, including but not
              limited to compiled object code, generated documentation, and
              conversions to other media types.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Work" shall mean the work of authorship, whether in Source or
              Object form, made available under the License,
              as&nbsp;indicated&nbsp;by a copyright notice that is included in
              or attached to the work (an example is provided in the Appendix
              below).&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Derivative Works" shall mean any work, whether in Source or
              Object form, that is based on (or derived from) the Work and for
              which the editorial revisions, annotations, elaborations, or other
              modifications&nbsp;represent, as a whole, an&nbsp;original work of
              authorship. For the purposes of this License, Derivative Works
              shall not include works that&nbsp;remain&nbsp;separable from, or
              merely link (or bind by name) to the interfaces of, the Work and
              Derivative Works thereof.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Contribution" shall mean any work of authorship, including the
              original version of the Work and any modifications or additions to
              that Work or Derivative Works thereof, that is
              intentionally&nbsp;submitted&nbsp;to Licensor for inclusion in the
              Work by the copyright owner or by an individual or Legal Entity
              authorized to&nbsp;submit&nbsp;on behalf of the copyright owner.
              For the purposes of this definition, "submitted" means any form of
              electronic, verbal, or written communication sent to the Licensor
              or its representatives, including but not limited to communication
              on electronic mailing lists, source code control systems,
              and&nbsp;issue tracking systems that are managed by, or on behalf
              of, the Licensor for the purpose of discussing and improving the
              Work, but excluding communication that is conspicuously marked or
              otherwise designated in writing by the copyright owner as "Not a
              Contribution."&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Contributor" shall mean Licensor and any individual or Legal
              Entity on behalf of whom a Contribution has been received by
              Licensor and&nbsp;subsequently&nbsp;incorporated within the
              Work.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>2. Grant of Copyright License&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Subject to the terms and conditions of this License, each
              Contributor hereby grants to You a perpetual, worldwide,
              non-exclusive, no-charge, royalty-free, irrevocable copyright
              license to reproduce, prepare Derivative Works of, publicly
              display, publicly perform, sublicense, and distribute the Work and
              such Derivative Works in Source or Object form.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>3. Grant of Patent License&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Subject to the terms and conditions of this License, each
              Contributor hereby grants to You a perpetual, worldwide,
              non-exclusive, no-charge, royalty-free, irrevocable (except as
              stated in this section) patent license to make, have made, use,
              offer to sell, sell, import, and otherwise transfer the Work,
              where such license applies only to those patent claims licensable
              by such Contributor that are necessarily infringed by their
              Contribution(s) alone or by combination of their Contribution(s)
              with the Work to which such Contribution(s) was submitted. If You
              institute patent litigation against any entity (including
              a&nbsp;cross-claim&nbsp;or counterclaim in a lawsuit) alleging
              that the Work or a Contribution incorporated within the Work
              constitutes direct or contributory patent infringement, then any
              patent licenses granted to You under this License for that Work
              shall&nbsp;terminate&nbsp;as of the date such litigation is
              filed.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>4. Redistribution&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              You may reproduce and distribute copies of the Work or Derivative
              Works thereof in any medium, with or without modifications, and in
              Source or Object form,&nbsp;provided that&nbsp;You meet the
              following conditions:&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              You must give any other recipients of the Work or Derivative Works
              a copy of this License; and&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              You must cause any modified files to carry prominent
              notices&nbsp;stating&nbsp;that You changed the files; and&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              You must&nbsp;retain, in the Source form of any Derivative Works
              that You distribute, all copyright, patent, trademark, and
              attribution notices from the Source form of the Work, excluding
              those notices that do not pertain to any part of the Derivative
              Works; and&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              If the Work includes a "NOTICE" text file as part of its
              distribution, then any Derivative Works that You distribute must
              include a readable copy of the attribution notices contained
              within such NOTICE file, excluding those notices that do not
              pertain to any part of the Derivative Works, in at least one of
              the following places: within a NOTICE text file distributed as
              part of the Derivative Works; within the Source form or
              documentation, if provided along with the Derivative Works; or,
              within a display generated by the Derivative Works, if and
              wherever such third-party notices normally appear. The contents of
              the NOTICE file are for informational purposes only and do
              not&nbsp;modify&nbsp;the License. You may add Your own attribution
              notices within Derivative Works that You distribute, alongside or
              as an addendum to the NOTICE text from the Work, provided that
              such&nbsp;additional&nbsp;attribution notices cannot&nbsp;be
              construed&nbsp;as&nbsp;modifying&nbsp;the License.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              You may add Your own copyright statement to Your modifications and
              may provide&nbsp;additional&nbsp;or different license terms and
              conditions for use, reproduction, or distribution of Your
              modifications, or for&nbsp;any such Derivative Works as a whole,
              provided Your use, reproduction, and distribution of the Work
              otherwise&nbsp;complies with&nbsp;the
              conditions&nbsp;stated&nbsp;in this License.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>5. Submission of Contributions&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Unless You explicitly&nbsp;state&nbsp;otherwise, any Contribution
              intentionally&nbsp;submitted&nbsp;for inclusion in the Work by You
              to the Licensor shall be under the terms and conditions of this
              License, without any&nbsp;additional&nbsp;terms or conditions.
              Notwithstanding the above, nothing&nbsp;herein&nbsp;shall
              supersede or&nbsp;modify&nbsp;the terms of any separate license
              agreement you may have executed with
              Licensor&nbsp;regarding&nbsp;such Contributions.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>6. Trademarks&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              This License does not grant permission to use the trade names,
              trademarks, service marks, or product names of the Licensor,
              except as&nbsp;required&nbsp;for reasonable and customary use in
              describing the origin of the Work and reproducing the content of
              the NOTICE file.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>7. Disclaimer of Warranty&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Unless required by applicable law or agreed to in writing,
              Licensor&nbsp;provides&nbsp;the Work (and each
              Contributor&nbsp;provides&nbsp;its Contributions) on an "AS IS"
              BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
              express or implied, including, without limitation, any warranties
              or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or
              FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible
              for&nbsp;determining&nbsp;the appropriateness of using or
              redistributing the Work and assume any risks associated with Your
              exercise of permissions under this License.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <h3>8. Limitation of Liability&nbsp;</h3>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              In no event and under no legal theory, whether in tort (including
              negligence), contract, or otherwise, unless required by applicable
              law (such as deliberate and grossly negligent acts) or agreed to
              in writing, shall any Contributor be liable to You for damages,
              including any direct, indirect, special, incidental, or
              consequential damages of any character arising as a result of this
              License or out of the use or inability to use the Work (including
              but not limited to damages for loss of goodwill, work stoppage,
              computer failure or malfunction, or any and all other commercial
              damages or losses), even if such Contributor has been advised of
              the possibility of such damages.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>IQKeyboardManager&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>MIT License&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Copyright (c) 2013-2017 Iftekhar&nbsp;Qurashi&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Permission is hereby granted, free of charge, to any person
              obtaining a copy of this software and associated documentation
              files (the "Software"), to deal in the Software without
              restriction, including without limitation the rights to use, copy,
              modify, merge, publish, distribute, sublicense, and/or sell copies
              of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The above copyright notice and this permission notice
              shall&nbsp;be included&nbsp;in all copies or substantial portions
              of the Software.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
              EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
              NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
              HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
              WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.&nbsp;
            </li>
          </ul>
          {/* <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>Realm-Mobile databas&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>Apache License&nbsp;</strong>
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>1. Definitions.</strong>&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "License" shall mean the terms and conditions for use,
              reproduction, and distribution as defined by Sections 1 through 9
              of this&nbsp;document.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Licensor" shall mean the copyright owner or entity authorized by
              the copyright owner that is granting the License.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Legal Entity" shall mean the union of the acting entity and all
              other entities that control, are controlled by, or are under
              common control with that entity. For the purposes of this
              definition, "control" means (i) the power, direct or indirect, to
              cause the direction or management of such entity, whether by
              contract or otherwise, or (ii) ownership of fifty percent (50%) or
              more of the outstanding shares, or (iii) beneficial ownership of
              such entity.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "You" (or "Your") shall mean an individual or Legal Entity
              exercising permissions granted by this License.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Source" form shall mean the preferred form for making
              modifications, including but not limited to software source code,
              documentation source, and configuration files.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Object" form shall mean any form resulting from mechanical
              transformation or translation of a Source form, including but not
              limited to compiled object code, generated documentation, and
              conversions to other media types.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Work" shall mean the work of authorship, whether in Source or
              Object form, made available under the License,
              as&nbsp;indicated&nbsp;by a copyright notice that is included in
              or attached to the work (an example is provided in the Appendix
              below).&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Derivative Works" shall mean any work, whether in Source or
              Object form, that is based on (or derived from) the Work and for
              which the editorial revisions, annotations, elaborations, or other
              modifications&nbsp;represent, as a whole, an&nbsp;original work of
              authorship. For the purposes of this License, Derivative Works
              shall not include works that&nbsp;remain&nbsp;separable from, or
              merely link (or bind by name) to the interfaces of, the Work and
              Derivative Works thereof.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Contribution" shall mean any work of authorship, including the
              original version of the Work and any modifications or additions to
              that Work or Derivative Works thereof, that is
              intentionally&nbsp;submitted&nbsp;to Licensor for inclusion in the
              Work by the copyright owner or by an individual or Legal Entity
              authorized to&nbsp;submit&nbsp;on behalf of the copyright owner.
              For the purposes of this definition, "submitted" means any form of
              electronic, verbal, or written communication sent to the Licensor
              or its representatives, including but not limited to communication
              on electronic mailing lists, source code control systems, and
              issue tracking systems that are managed by, or on behalf of, the
              Licensor for the purpose of discussing and improving the Work, but
              excluding communication that is conspicuously marked or otherwise
              designated in writing by the copyright owner as "Not a
              Contribution."&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Contributor" shall mean Licensor and any individual or Legal
              Entity on behalf of whom a Contribution has been received by
              Licensor and&nbsp;subsequently&nbsp;incorporated within the
              Work.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>2. Grant of Copyright License.</strong> Subject to the
              terms and conditions of this License, each Contributor hereby
              grants to You a perpetual, worldwide, non-exclusive, no-charge,
              royalty-free, irrevocable copyright license to reproduce, prepare
              Derivative Works of, publicly display, publicly perform,
              sublicense, and distribute the Work and such Derivative Works in
              Source or Object form.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>3. Grant of Patent License.</strong> Subject to the terms
              and conditions of this License, each Contributor hereby grants to
              You a perpetual, worldwide, non-exclusive, no-charge,
              royalty-free, irrevocable (except as stated in this section)
              patent license to make, have made, use, offer to sell, sell,
              import, and otherwise transfer the Work, where such license
              applies only to those patent claims licensable by such Contributor
              that are necessarily infringed by their Contribution(s) alone or
              by combination of their Contribution(s) with the Work to which
              such Contribution(s) was submitted. If You institute patent
              litigation against any entity (including
              a&nbsp;cross-claim&nbsp;or counterclaim in a lawsuit) alleging
              that the Work or a Contribution incorporated within the Work
              constitutes direct or contributory patent infringement, then any
              patent licenses granted to You under this License for that Work
              shall&nbsp;terminate&nbsp;as of the date such litigation is
              filed.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>4. Redistribution.</strong> You may reproduce and
              distribute copies of the Work or Derivative Works thereof in any
              medium, with or without modifications, and in Source or Object
              form,&nbsp;provided that&nbsp;You meet the following
              conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              You must give any other recipients of the Work or Derivative Works
              a copy of this License; and&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              You must cause any modified files to carry prominent
              notices&nbsp;stating&nbsp;that You changed the files; and&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              You must&nbsp;retain, in the Source form of any Derivative Works
              that You distribute, all copyright, patent, trademark, and
              attribution notices from the Source form of the Work, excluding
              those notices that do not pertain to any part of the Derivative
              Works; and&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              If the Work includes a "NOTICE" text file as part of its
              distribution, then any Derivative Works that You distribute must
              include a readable copy of the attribution notices contained
              within such NOTICE file, excluding those notices that do not
              pertain to any part of the Derivative Works, in at least one of
              the following places: within a NOTICE text file distributed as
              part of the Derivative Works; within the Source form or
              documentation, if provided along with the Derivative Works; or,
              within a display generated by the Derivative Works, if and
              wherever such third-party notices normally appear. The contents of
              the NOTICE file are for informational purposes only and do
              not&nbsp;modify&nbsp;the License. You may add Your own attribution
              notices within Derivative Works that You distribute, alongside or
              as an addendum to the NOTICE text from the Work, provided that
              such&nbsp;additional&nbsp;attribution notices cannot&nbsp;be
              construed&nbsp;as&nbsp;modifying&nbsp;the License.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              You may add Your own copyright statement to Your modifications and
              may provide&nbsp;additional&nbsp;or different license terms and
              conditions for use, reproduction, or distribution of Your
              modifications, or for any such Derivative Works as a whole,
              provided Your use, reproduction, and distribution of the Work
              otherwise&nbsp;complies with&nbsp;the
              conditions&nbsp;stated&nbsp;in this License.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>5. Submission of Contributions.</strong> Unless You
              explicitly&nbsp;state&nbsp;otherwise, any Contribution
              intentionally&nbsp;submitted&nbsp;for inclusion in the Work by You
              to the Licensor shall be under the terms and conditions of this
              License, without any&nbsp;additional&nbsp;terms or conditions.
              Notwithstanding the above, nothing&nbsp;herein&nbsp;shall
              supersede or&nbsp;modify&nbsp;the terms of any separate license
              agreement you may have executed with
              Licensor&nbsp;regarding&nbsp;such Contributions.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>6. Trademarks.</strong> This License does not grant
              permission to use the trade names, trademarks, service marks, or
              product names of the Licensor, except as&nbsp;required&nbsp;for
              reasonable and customary use in describing the origin of the Work
              and reproducing the content of the NOTICE file.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>7. Disclaimer of Warranty.</strong> Unless required by
              applicable law or agreed to in writing,
              Licensor&nbsp;provides&nbsp;the Work (and each
              Contributor&nbsp;provides&nbsp;its Contributions) on an "AS IS"
              BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
              express or implied, including, without limitation, any warranties
              or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or
              FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible
              for&nbsp;determining&nbsp;the appropriateness of using or
              redistributing the Work and assume any risks associated with Your
              exercise of permissions under this License.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>8. Limitation of Liability.</strong> In no event and under
              no legal theory, whether in tort (including negligence), contract,
              or otherwise, unless required by applicable law (such as
              deliberate and grossly negligent acts) or agreed to in writing,
              shall any Contributor be liable to You for damages, including any
              direct, indirect, special, incidental, or consequential damages of
              any character arising as a result of this License or out of the
              use or inability to use the Work (including but not limited to
              damages for loss of goodwill, work stoppage, computer failure or
              malfunction, or any and all other commercial damages or losses),
              even if such Contributor has been advised of the possibility of
              such damages.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>9. Accepting Warranty or Additional Liability.</strong>{" "}
              While redistributing the Work or Derivative Works
              thereof,&nbsp;You&nbsp;may choose to offer, and charge a fee for,
              acceptance of support, warranty, indemnity, or other liability
              obligations and/or rights consistent with this License. However,
              in accepting such obligations, You may act only on Your own behalf
              and on Your sole responsibility, not on behalf of any other
              Contributor, and only if You agree to indemnify, defend, and hold
              each Contributor harmless for any liability incurred by, or claims
              asserted against, such Contributor by reason of your accepting any
              such warranty or additional liability.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              END OF TERMS AND CONDITIONS&nbsp;
              <br />
              &nbsp;
            </li>
          </ul> */}

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>Kingfisher&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>The MIT License (MIT)&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">Copyright (c) 2019 Wei Wang</li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Permission is hereby granted, free of charge, to any person
              obtaining a copy&nbsp;of this software and associated
              documentation files (the "Software"), to deal&nbsp;in the Software
              without restriction, including without limitation the
              rights&nbsp;to use, copy, modify, merge, publish, distribute,
              sublicense, and/or sell&nbsp;copies of the Software, and to permit
              persons to whom the Software is&nbsp;furnished to do so, subject
              to the following conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The above copyright notice and this permission notice shall be
              included in all&nbsp;copies or substantial portions of the
              Software.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
              EXPRESS OR&nbsp;IMPLIED, INCLUDING BUT NOT LIMITED TO THE
              WARRANTIES OF MERCHANTABILITY,&nbsp;FITNESS FOR A PARTICULAR
              PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE&nbsp;AUTHORS OR
              COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
              OTHER&nbsp;LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
              OTHERWISE, ARISING FROM,&nbsp;OUT OF OR IN CONNECTION WITH THE
              SOFTWARE OR THE USE OR OTHER DEALINGS IN THE&nbsp;SOFTWARE.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>Alamofire&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>The MIT License&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Copyright (c) 2014-2022&nbsp;Alamofire&nbsp;Software
              Foundation&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              &nbsp;
              <br />
              Permission is hereby granted, free of charge, to any person
              obtaining a copy of this software and associated documentation
              files (the "Software"), to deal in the Software without
              restriction, including without limitation the rights to use, copy,
              modify, merge, publish, distribute, sublicense, and/or sell copies
              of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The above copyright notice and this permission notice shall be
              included in all copies or substantial portions of the
              Software.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
              EXPRESS OR IMPLIED,&nbsp;INCLUDING BUT NOT LIMITED TO&nbsp;THE
              WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
              PARTICULAR&nbsp;PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
              OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
              OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
              OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>Firebase Cloud&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>Apache License&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              &nbsp;
              <br />
              Copyright 2017 The Chromium Authors. All rights
              reserved.&nbsp;Redistribution and use in source and binary forms,
              with or without&nbsp;modification,
              are&nbsp;permitted&nbsp;provided that the following
              conditions&nbsp;are met: &nbsp;&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              &nbsp;* Redistributions of source code must&nbsp;retain&nbsp;the
              above copyright notice, this list of conditions and the following
              disclaimer. &nbsp;&nbsp;&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              * Redistributions in binary form must reproduce the above
              copyright notice, this list of conditions and the&nbsp;following
              &nbsp;disclaimer&nbsp;in the documentation and/or other materials
              provided with the distribution. &nbsp;&nbsp;
              <br /> * Neither the name of Google Inc. nor the names of its
              contributors may be used to endorse or promote products derived
              from this software without specific prior written
              permission.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND
              CONTRIBUTORS"AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
              INCLUDING, BUT NOTLIMITED TO, THE IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS FORA PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHTOWNER OR CONTRIBUTORS
              BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,SPECIAL, EXEMPLARY,
              OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOTLIMITED TO,
              PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,DATA, OR
              PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANYTHEORY
              OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR
              TORT(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF
              THE USEOF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
              SUCH DAMAGE.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>MBProgressHUDSDP</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>MIT License&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Copyright &copy; 2009-2020 Matej&nbsp;Bukovinski&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Permission is hereby granted, free of charge, to any person
              obtaining a copy&nbsp;of this software and associated
              documentation files (the "Software"), to deal&nbsp;in the Software
              without restriction, including without limitation the
              rights&nbsp;to use, copy, modify, merge, publish, distribute,
              sublicense, and/or sell&nbsp;copies of the Software, and to permit
              persons to whom the Software is&nbsp;furnished to do so, subject
              to the following conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The above copyright notice and this permission notice
              shall&nbsp;be included&nbsp;in all&nbsp;copies or substantial
              portions of the Software.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
              EXPRESS OR&nbsp;IMPLIED, INCLUDING BUT NOT LIMITED TO THE
              WARRANTIES OF MERCHANTABILITY,&nbsp;FITNESS FOR A PARTICULAR
              PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE&nbsp;AUTHORS OR
              COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
              OTHER&nbsp;LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
              OTHERWISE, ARISING FROM,&nbsp;OUT OF OR IN CONNECTION WITH THE
              SOFTWARE OR THE USE OR OTHER DEALINGS IN THE&nbsp;SOFTWARE.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">ObjectMapper</li>
          </ul>

          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">MIT License&nbsp;</li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">Copyright (c) 2014 Hearst&nbsp;</li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Permission is hereby granted, free of charge, to any person
              obtaining a copy of this software and associated documentation
              files (the "Software"), to deal in the Software without
              restriction, including without limitation the rights to use, copy,
              modify, merge, publish, distribute, sublicense, and/or sell copies
              of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The above copyright notice and this permission notice shall be
              included in all copies or substantial portions of the
              Software.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
              EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
              NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
              HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
              WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>TTGSnackbar&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>MIT License&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">Copyright (c) 2015&nbsp;zekunyan&nbsp;</li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Permission is hereby granted, free of charge, to any person
              obtaining a copy of this software and associated documentation
              files (the "Software"), to deal in the Software without
              restriction, including without limitation the rights to use, copy,
              modify, merge, publish, distribute, sublicense, and/or sell copies
              of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The above copyright notice and this permission notice shall be
              included in all copies or substantial portions of the
              Software.&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
              EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
              NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
              HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
              WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.&nbsp;
            </li>
          </ul>
          {/* <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>DPOTPView-OTP implementation&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>Apache License&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>Version 2.0, January 2004</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>http://www.apache.org/licenses/</strong>
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND
              DISTRIBUTION&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>1. Definitions.</strong>&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "License" shall mean the terms and conditions for use,
              reproduction, and distribution as defined by Sections 1 through 9
              of this&nbsp;document.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Licensor" shall mean the copyright owner or entity authorized by
              the copyright owner that is granting the License.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Legal Entity" shall mean the union of the acting entity and all
              other entities that control, are controlled by, or are under
              common control with that entity. For the purposes of this
              definition, "control" means (i) the power, direct or indirect, to
              cause the direction or management of such entity, whether by
              contract or otherwise, or (ii) ownership of fifty percent (50%) or
              more of the outstanding shares, or (iii) beneficial ownership of
              such entity.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "You" (or "Your") shall mean an individual or Legal Entity
              exercising permissions granted by this License.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Source" form shall mean the preferred form for making
              modifications, including but not limited to software source code,
              documentation source, and configuration files.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Object" form shall mean any form resulting from mechanical
              transformation or translation of a Source form, including but not
              limited to compiled object code, generated documentation, and
              conversions to other media types.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Work" shall mean the work of authorship, whether in Source or
              Object form, made available under the License,
              as&nbsp;indicated&nbsp;by a copyright notice that&nbsp;is
              included&nbsp;in or attached to the work (an example is provided
              in the Appendix below).&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Derivative Works" shall mean any work, whether in Source or
              Object form,&nbsp;that&nbsp;is based on (or derived from) the Work
              and for which the editorial revisions, annotations, elaborations,
              or other modifications&nbsp;represent, as a whole,
              an&nbsp;original work of authorship. For the purposes of this
              License, Derivative Works shall not include works
              that&nbsp;remain&nbsp;separable from, or merely link (or bind by
              name) to the interfaces of, the Work and Derivative Works
              thereof.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Contribution" shall mean any work of authorship, including the
              original version of the Work and any modifications or additions to
              that Work or Derivative Works thereof, that is
              intentionally&nbsp;submitted&nbsp;to Licensor for inclusion in the
              Work by the copyright owner or by an individual or Legal Entity
              authorized to&nbsp;submit&nbsp;on behalf of the copyright owner.
              For the purposes of this definition, "submitted" means
              any&nbsp;form of electronic, verbal, or written communication sent
              to the Licensor or its representatives, including but not limited
              to communication on electronic mailing lists, source code control
              systems, and issue tracking systems that are managed by, or on
              behalf of, the Licensor for the purpose of discussing and
              improving the Work, but excluding communication that is
              conspicuously marked or otherwise designated in writing by the
              copyright owner as "Not a Contribution."&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              "Contributor" shall mean Licensor and any individual or Legal
              Entity on behalf of whom a Contribution has been received by
              Licensor and&nbsp;subsequently&nbsp;incorporated within the
              Work.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>2. Grant of Copyright License.</strong> Subject to the
              terms and conditions of this License, each Contributor hereby
              grants to You a perpetual, worldwide, non-exclusive, no-charge,
              royalty-free, irrevocable copyright license to reproduce, prepare
              Derivative Works of, publicly display, publicly perform,
              sublicense, and distribute the Work and such Derivative Works in
              Source or Object form.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>3. Grant of Patent License.</strong> Subject to the terms
              and conditions of this License, each Contributor hereby grants to
              You a perpetual, worldwide, non-exclusive, no-charge,
              royalty-free, irrevocable (except as stated in this section)
              patent license to make, have made, use, offer to sell, sell,
              import, and otherwise transfer the Work, where such license
              applies only to those patent claims licensable by such Contributor
              that are necessarily infringed by their Contribution(s) alone or
              by combination of their Contribution(s) with the Work to which
              such Contribution(s) was submitted. If You institute patent
              litigation against any entity (including
              a&nbsp;cross-claim&nbsp;or counterclaim in a lawsuit) alleging
              that the Work or a Contribution incorporated within the Work
              constitutes direct or contributory patent infringement, then any
              patent licenses granted to You under this License for that Work
              shall&nbsp;terminate&nbsp;as of the date such litigation is
              filed.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>4. Redistribution.</strong> You may reproduce and
              distribute copies of the Work or Derivative Works thereof in any
              medium, with or without modifications, and in Source or Object
              form,&nbsp;provided that&nbsp;You meet the following
              conditions:&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              (a) You must give any other recipients of the Work or Derivative
              Works a copy of this License; and&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              (b) You must cause any modified files to carry prominent
              notices&nbsp;stating&nbsp;that You changed the files;
              and&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              (c) You must&nbsp;retain, in the Source form of any Derivative
              Works that You distribute, all copyright, patent, trademark, and
              attribution notices from the Source form of the Work, excluding
              those notices that do not pertain to any part of the Derivative
              Works; and&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              (d) If the Work includes a "NOTICE" text file as part of its
              distribution, then any Derivative Works that You distribute must
              include a readable copy of the attribution notices contained
              within such NOTICE file, excluding those notices that do not
              pertain to any part of the Derivative Works, in at least one of
              the&nbsp;following places: within a NOTICE text file distributed
              as part of the Derivative Works; within the Source form or
              documentation, if provided along with the Derivative Works; or,
              within a display generated by the Derivative Works, if and
              wherever such third-party notices normally appear. The contents of
              the NOTICE file are for informational purposes only and do
              not&nbsp;modify&nbsp;the License. You may add Your own attribution
              notices within Derivative Works that You distribute, alongside or
              as an addendum to the NOTICE text from the Work, provided that
              such&nbsp;additional&nbsp;attribution notices cannot&nbsp;be
              construed&nbsp;as&nbsp;modifying&nbsp;the License. You may add
              Your own copyright statement to Your modifications and may
              provide&nbsp;additional&nbsp;or different license terms and
              conditions for use, reproduction, or distribution of Your
              modifications, or for any such Derivative Works as a whole,
              provided Your use, reproduction, and distribution of the Work
              otherwise&nbsp;complies with&nbsp;the
              conditions&nbsp;stated&nbsp;in this License.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>5. Submission of Contributions.</strong> Unless You
              explicitly&nbsp;state&nbsp;otherwise, any Contribution
              intentionally&nbsp;submitted&nbsp;for inclusion in the Work by You
              to the Licensor shall be under the terms and conditions of this
              License, without any&nbsp;additional&nbsp;terms or conditions.
              Notwithstanding the above, nothing&nbsp;herein&nbsp;shall
              supersede or&nbsp;modify&nbsp;the terms of any separate license
              agreement you may have executed with
              Licensor&nbsp;regarding&nbsp;such Contributions.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>6. Trademarks.</strong> This License does not grant
              permission to use the trade names, trademarks, service marks, or
              product names of the Licensor, except as&nbsp;required&nbsp;for
              reasonable and customary use in describing the origin of the Work
              and reproducing the content of the NOTICE file.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>7. Disclaimer of Warranty.</strong> Unless required by
              applicable law or agreed to in writing,
              Licensor&nbsp;provides&nbsp;the Work (and each
              Contributor&nbsp;provides&nbsp;its Contributions) on an "AS IS"
              BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
              express or implied, including, without limitation, any warranties
              or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or
              FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible
              for&nbsp;determining&nbsp;the appropriateness of using or
              redistributing the Work and assume any risks associated with Your
              exercise of permissions under this License.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>8. Limitation of Liability.</strong> In no event and under
              no legal theory, whether in tort (including negligence), contract,
              or otherwise, unless required by applicable law (such as
              deliberate and grossly negligent acts) or agreed to in writing,
              shall any Contributor be liable to You for damages, including any
              direct, indirect, special, incidental, or consequential damages of
              any character arising as a result of this License or out of the
              use or inability to use the Work (including but not limited to
              damages for loss of goodwill, work stoppage, computer failure or
              malfunction, or any and all other commercial damages or losses),
              even if such Contributor has been advised of the possibility of
              such damages.&nbsp;&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>9. Accepting Warranty or Additional Liability.</strong>{" "}
              While redistributing the Work or Derivative Works
              thereof,&nbsp;You&nbsp;may choose to offer, and charge a fee for,
              acceptance of support, warranty, indemnity, or other liability
              obligations and/or rights consistent
              with&nbsp;this&nbsp;&nbsp;License. However, in accepting such
              obligations, You may act only on Your own behalf and on Your sole
              responsibility, not on behalf of any other Contributor, and only
              if You agree to indemnify, defend, and hold each Contributor
              harmless for any liability incurred by, or claims asserted
              against, such Contributor by reason of your accepting any such
              warranty or additional liability.&nbsp;&nbsp;
            </li>
          </ul> */}
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>SideMenu&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-ul_style">
            <li role="presentation">
              <strong>MIT License&nbsp;</strong>
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              <strong>
                Copyright (c) 2015 Jonathan Kent contact@jonkent.me
              </strong>
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              Permission is hereby granted, free of charge, to any person
              obtaining a copy of this software and associated documentation
              files (the "Software"), to deal in the Software without
              restriction, including without limitation the rights to use, copy,
              modify, merge, publish, distribute, sublicense, and/or sell copies
              of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:&nbsp;
            </li>
          </ul>
          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              The above copyright notice and this permission notice
              shall&nbsp;be included&nbsp;in all copies or substantial portions
              of the Software.&nbsp;
            </li>
          </ul>

          <ul className="license-jioimmerse-wrapper-content">
            <li role="presentation">
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
              EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
              NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
              HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
              WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
              DEALINGS IN THE SOFTWARE.&nbsp;
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Licences;
